import { useEffect } from "react";
import tvgConf from "@tvg/conf";
import mediator from "@tvg/mediator";
import { handleNativeCameraAccess } from "../utils/handlers";

const useNativeCameraAccess = (status, dispatch) => {
  useEffect(() => {
    const mobileProducts = ["iosnative", "androidwrapper", "tvgandroid"];
    const { product } = tvgConf();

    if (
      status === "onfidoError" &&
      window !== undefined &&
      mobileProducts.includes(product)
    ) {
      // Check iOS RN camera access
      if (product === "iosnative") {
        mediator.base.subscribe(
          "RN_CAMERA_ACCESS_RESPONSE",
          handleNativeCameraAccess(dispatch)
        );
      } else {
        if (["androidwrapper", "tvgandroid"].includes(product)) {
          if (
            navigator &&
            navigator.mediaDevices &&
            navigator.mediaDevices.getUserMedia
          ) {
            const constrains = { audio: true, video: true };
            navigator.mediaDevices.getUserMedia(constrains);
          }
        }
        mediator.ios.subscribe(
          "RN_CAMERA_ACCESS_RESPONSE",
          handleNativeCameraAccess(dispatch)
        );
      }
    }

    return () => {
      if (
        status === "onfidoError" &&
        window !== undefined &&
        mobileProducts.includes(product)
      ) {
        if (product === "iosnative") {
          mediator.base.unsubscribe(
            "RN_CAMERA_ACCESS_RESPONSE",
            handleNativeCameraAccess(dispatch)
          );
        } else {
          mediator.ios.unsubscribe(
            "RN_CAMERA_ACCESS_RESPONSE",
            handleNativeCameraAccess(dispatch)
          );
        }
      }
    };
  }, [status]);
};

export default useNativeCameraAccess;
